import { render } from "./HomeMobile.vue?vue&type=template&id=4be8be9a&scoped=true&ts=true"
import script from "./HomeMobile.vue?vue&type=script&lang=ts"
export * from "./HomeMobile.vue?vue&type=script&lang=ts"

import "./HomeMobile.vue?vue&type=style&index=0&id=4be8be9a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be8be9a"]])

export default __exports__